import { internal, template } from '../../vendor/elix.js';

function OutlinedInputMixin(Base) {

  return class OutlinedInput extends Base {

    get [internal.template]() {

      const innerSelector = this.innerSelector || '#inner';

      return template.concat(

        super[internal.template],

        template.html`

          <style>

            :host {
              outline: none;
              position: relative;
            }

            ${innerSelector} {
              border: var(--tp-outlined-input-mixin-border-width) solid var(--tp-outlined-input-mixin-border-color);
              border-radius: 4px;
              outline: none;
              padding: var(--tp-outlined-input-mixin-padding);
              transition: var(--tp-outlined-input-mixin-transition);
            }

            .inputStateContainer {
              transition: var(--tp-outlined-input-mixin-transition);
            }

            .inputStateContainer.disabled ${innerSelector} {
              border-color:  var(--tp-outlined-input-mixin-border-color-disabled);
            }

            .inputStateContainer:not(.disabled):not(.error):hover ${innerSelector} {
              border-color: var(--tp-outlined-input-mixin-border-color-hover);
              border-width: var(--tp-outlined-input-mixin-border-width-hover);
              padding: var(--tp-outlined-input-mixin-padding-hover);
            }

            .inputStateContainer:not(.disabled) ${innerSelector}:focus,
            .inputStateContainer:not(.disabled) ${innerSelector}:active {
              border-width: var(--tp-outlined-input-mixin-border-width-focused);
              padding: var(--tp-outlined-input-mixin-padding-focused);
            }

            .inputStateContainer:not(.disabled):not(.error) ${innerSelector}:focus,
            .inputStateContainer:not(.disabled):not(.error) ${innerSelector}:active {
              border-color:  var(--tp-outlined-input-mixin-border-color-focused);
            }

            .inputStateContainer.error ${innerSelector} {
              border-color:  var(--tp-outlined-input-mixin-border-color-error);
              border-width: var(--tp-outlined-input-mixin-border-width-error);
              padding: var(--tp-outlined-input-mixin-padding-error);
            }

            .inputStateContainer.with-leading-slot-contents ${innerSelector} {
              padding-left: 50px !important;
            }

            .inputStateContainer.with-trailing-slot-contents ${innerSelector} {
              padding-right: 50px !important;
            }

            .errortext,
            .helpertext {
              margin-left: 16px;
              margin-top: 4px;
            }

          </style>
        `
      );

    }

  }

}

export default OutlinedInputMixin;
